export const UPDATE_SUCCESS = 'Changes successfully saved.';
export const UPDATE_ERROR = 'Something went wrong. Failed to save changes.';
